// cmdk's default scorer is a subsequence match, so "bas" hits any value with a
// b, an a, and an s in order. We require real substrings instead.
const WORD_BOUNDARY = /[^a-z0-9]/

const EXACT_START = 1
const WORD_START = 0.9
const INNER = 0.5
const KEYWORD_WEIGHT = 0.4

function scoreToken(
	haystack: string,
	token: string,
	allowInnerMatch: boolean,
): number {
	let best = 0
	let index = haystack.indexOf(token)
	while (index !== -1) {
		const isWordStart =
			index === 0 || WORD_BOUNDARY.test(haystack[index - 1] ?? "")
		const score = isWordStart
			? index === 0
				? EXACT_START
				: WORD_START
			: allowInnerMatch
				? INNER
				: 0
		if (score > best) best = score
		if (best === EXACT_START) return best
		index = haystack.indexOf(token, index + 1)
	}
	return best
}

export function cmdkFilter(
	value: string,
	search: string,
	keywords?: Array<string>,
): number {
	const query = search.trim().toLowerCase()
	if (!query) return 1

	const haystack = value.toLowerCase()
	const keywordHaystack = (keywords ?? []).join(" ").toLowerCase()

	let total = 0
	const tokens = query.split(/\s+/)
	for (const token of tokens) {
		// Keywords only match at a word start, so "bas" no longer pulls in
		// PostgreSQL through "database".
		const score = Math.max(
			scoreToken(haystack, token, true),
			scoreToken(keywordHaystack, token, false) * KEYWORD_WEIGHT,
		)
		if (score === 0) return 0
		total += score
	}

	return total / tokens.length
}
